import styled from 'styled-components';

export const DateGroupStyled = styled.div`
  .date_group_wrap {
    display: flex;
    column-gap: 10px;
    align-items: flex-end;
    .dg_input_wrap {
      min-width: 150px;
    }
    .custom_date {
      min-width: 140px;
    }
  }

  .theme_standard {
  }
`;
